
import {LoginConfig} from '@/store/Constraints';
import {MemberApi} from '@/api/Api';
import {Axios,setAuthToken} from '@/api/Axios';
import {AppConfig} from '@/config/AppConfig';
import {LocalStorageConfig} from '@/components/AppConstants';
import { reject } from 'lodash';
// import {Axios} from '@/api/Api';
const LoginStore = {
  state: {
    // loginState: {state: false, code: ''},
    loginState: false,
    loginData: {},
    
    logoutData: {},
    findIdData: {},
    findPwData: {},
    snsLoginData: {},

    memberNo:null,
    accessToken:null,
    memberData:null,

    mainData:{},


    kakao_init:false,

  },
  getters: {
    [LoginConfig.LOGIN_DATA]: (state) => state.loginData,
    [LoginConfig.LOGIN_STATE]: (state) => state.loginState,
    [LoginConfig.MAIN_DATA]: (state) => state.mainData,
    [LoginConfig.MEMBER_NO]: (state) => state.memberNo,
    [LoginConfig.ACCESS_TOKEN]: (state) => state.accessToken,
    [LoginConfig.MEMBER_DATA]: (state) => state.memberData,

    [LoginConfig.KAKAO_INIT]: (state) => state.kakao_init,
  },
  mutations: {

    [LoginConfig.KAKAO_INIT]:(state,payload) =>{
      console.log(`LoginStore.mutations.KAKAO_INIT => ${payload}`);
      state.kakao_init = payload
    },


    [LoginConfig.MEMBER_DATA]: (state, payload) => {
      console.log(`LoginStore.mutations.MEMBER_DATA => ${JSON.stringify(payload)}`);
      state.memberData = payload;
    },
    [LoginConfig.MEMBER_NO]: (state, payload) => {
      console.log(`LoginStore.mutations.MEMBER_NO => ${JSON.stringify(payload)}`);
      state.memberNo = payload;
    },
    [LoginConfig.MAIN_DATA]: (state, payload) => {
      console.log(`LoginStore.mutations.MAIN_DATA => ${JSON.stringify(payload)}`);
      state.mainData = payload;
    },
    [LoginConfig.LOGIN_DATA]: (state, payload) => {
      console.log(`LoginStore.mutations.LOGIN_DATA => ${JSON.stringify(payload)}`);
      state.loginData = payload;      
    },
    [LoginConfig.LOGIN_STATE]: (state, payload) => {
      console.log(`LoginStore.mutations.LOGIN_STATE => ${JSON.stringify(payload)}`);
      // state.memberNo = payload.memberNo;
      state.loginState = payload;//(payload.code === '0000') ? true : false;
    },
    // [LoginConfig.LOGIN_EVENT]: (state, payload) => {
    //   console.log(`LoginStore.mutations.LOGIN_EVENT => ${JSON.stringify(payload)}`);
    //   // state.loginData = {memberNo:payload.memberNo,needDi:payload.needDi,dormantYn:payload.dormantYn};
    //   state.loginData = payload;
    //   state.loginState = true;//(payload.code === '0000') ? true : false;
    // },

    // [LoginConfig.LOGOUT_EVENT]: (state, payload) => {
      
    //   state.loginData = {};
    //   state.accessToken = '';
    //   state.logoutData = payload;
    //   state.loginState = false;

    //   setAuthToken('');
    // },
    [LoginConfig.FIND_ID_EVENT]: (state, payload) => {
      state.findIdData = payload;
    },
    [LoginConfig.FIND_PW_EVENT]: (state, payload) => {
      state.findPwData = payload;
    },

    // [LoginConfig.MEMBER_NO]: (state, payload) => {
    //   state.memberNo = payload;
    // },
    [LoginConfig.ACCESS_TOKEN]: (state, payload) => {
      console.log(`LoginStore.mutations.ACCESS_TOKEN => ${payload}`);
      state.accessToken = payload;
      // state.loginState = true;
      localStorage.setItem(LocalStorageConfig.AccessToken,payload)
      setAuthToken( payload);
    },
  },
  actions: {

    [LoginConfig.LOGIN_DEVICE_EVENT]:(store,payload) =>{

      console.log(`LoginStore.actions.LOGIN_DEVICE_EVENT=> ${payload}`);
      // store.commit(LoginConfig.MEMBER_NO, payload.memberNo)
      store.commit(LoginConfig.ACCESS_TOKEN, payload)
      

      //get MemberInfo
      Axios.get(MemberApi.GET_MEMBER_INFO)
      .then(member_res =>{   
        
        if(member_res.code == '0000'){
          store.commit(LoginConfig.MEMBER_DATA,member_res.data)
          store.commit(LoginConfig.LOGIN_STATE,true)
        }
      })
      .catch(err => {
        throw err
      })
    },

    
    [LoginConfig.LOGIN_EVENT]: (store, payload) => {

      return new Promise(async(resolve,reject) => {

        Axios.post(MemberApi.LOGIN,payload)
        .then(login_res => {        
          if(login_res.code === '0000'){          
            store.commit(LoginConfig.MEMBER_NO,login_res.data.memberNo)
            store.commit(LoginConfig.LOGIN_DATA,login_res.data)

            if(AppConfig.VUE_APP_IS_DEV && !AppConfig.VUE_APP_MOBILE_ONLY){
              //get accessToken
              Axios.post(MemberApi.AUTHENTICATE,{memberNo:login_res.data.memberNo,pw:payload.pw})
              .then(auth_res =>{              
                  if(auth_res.code == '0000'){
                      //accessToken
                      store.commit(LoginConfig.ACCESS_TOKEN,auth_res.data.accessToken)

                      

                      //get MemberInfo
                      Axios.get(MemberApi.GET_MEMBER_INFO)
                      .then(member_res =>{   
                        
                        if(member_res.code == '0000'){
                          store.commit(LoginConfig.MEMBER_DATA,member_res.data)
                          store.commit(LoginConfig.LOGIN_STATE,true)
                          resolve()
                        }else{
                          reject(member_res)
                        }
                      })
                      .catch(err => {
                        reject(err)
                    })
                  }
              })
              .catch(err => {
                reject(err)
              })
            }else{
              resolve();
            }
            
          }else{
            reject(login_res)
          }
          
        })
        .catch(err => {
          reject(err)
        })
      })
      
    },

    
    [LoginConfig.FIND_ID_EVENT]: (store, payload) => {      
      return new Promise((resolve,reject) => {
        Axios.post(MemberApi.FIND_ID,payload)
        .then(res =>{   
          resolve(res)          
        })
        .catch(err => {
          console.log(err);
          reject(err)
        })
      })
    },
    [LoginConfig.FIND_PW_EVENT]: (store, payload) => {
      return new Promise((resolve,reject) => {
        Axios.post(MemberApi.FIND_PWD,payload)
        .then(res =>{   
          resolve(res)          
        })
        .catch(err => {
          console.log(err);
          reject(err)
        })
      })
    },
    
    [LoginConfig.JOIN_EVENT]:(store ,payload) => {

      console.log(`LoginStore.actions.JOIN_EVENT -> payload : ${JSON.stringify(payload)}`);
      return new Promise(async(resolve,reject) => {
        Axios.post(MemberApi.JOIN,payload)
        .then(res => {        
          console.log(`LoginStore.actions.JOIN_EVENT -> res: ${JSON.stringify(res)}`);
          if(res.code === '0000'){          
            // store.commit(LoginConfig.MEMBER_NO,res.data.memberNo)
            resolve(res)            
          }else{
            reject(res)
          }
        })
        .catch(err =>{
          console.log(`LoginStore.actions.JOIN_EVENT -> err: ${JSON.stringify(err)}`);
          reject(err)
        })
      })
    },
    
    [LoginConfig.LOGOUT_EVENT]: (store, payload) => {

      let loginInfoString = localStorage.getItem(LocalStorageConfig.AutoLoginInfo);
      console.log(`LoginStore.actions.LOGOUT_EVENT -> loginInfoString : ${loginInfoString}`);
      let loginInfo = JSON.parse(loginInfoString);

      console.log(`LoginStore.actions.LOGOUT_EVENT -> loginInfo : ${JSON.stringify(loginInfo)}`);

      if(loginInfo.type == 'KAKAO'){        
            store.dispatch(LoginConfig.KAKAO_LOGOUT,{})
      }else if(loginInfo.type == 'NAVER'){            
      }else if(loginInfo.type == 'GOOGLE'){            
      }else if(loginInfo.type == 'FACEBOOK'){            
      }else if(loginInfo.type == 'APPLE'){            
      }else {            
        
      }

      store.commit(LoginConfig.LOGIN_STATE,false)
      store.commit(LoginConfig.LOGIN_DATA,null)
      store.commit(LoginConfig.MEMBER_DATA,null)
      store.commit(LoginConfig.ACCESS_TOKEN,null)   
      
      Axios.removeAccessToken();

      localStorage.removeItem(LocalStorageConfig.AutoLoginInfo);


    },

    //process sns login
    [LoginConfig.LOGIN_WITH_SNS_EVENT]:(store ,payload) => {
      
      console.log(`LoginStore.actions.LOGIN_WITH_SNS_EVENT -> payload : ${JSON.stringify(payload)}`);
      return new Promise(async(resolve,reject) => {
        // // // GongCha 처리              
        Axios.post(MemberApi.LOGIN_SNS,payload)
        .then(login_res => {        
          console.log(`LoginStore.actions.LOGIN_WITH_SNS_EVENT -> login_res : ${JSON.stringify(login_res)}`);

          if(login_res.code === '0000'){          
            store.commit(LoginConfig.MEMBER_NO,login_res.data.memberNo)
            store.commit(LoginConfig.LOGIN_DATA,login_res.data)

            if(AppConfig.VUE_APP_IS_DEV && !AppConfig.VUE_APP_MOBILE_ONLY){
              //get accessToken
              Axios.post(MemberApi.AUTHENTICATE,{memberNo:login_res.data.memberNo,pw:payload.pw})
              .then(auth_res =>{            
                
                console.log(`LoginStore.actions.LOGIN_WITH_SNS_EVENT -> auth_res : ${JSON.stringify(auth_res)}`);

                if(auth_res.code == '0000'){
                    //accessToken
                    store.commit(LoginConfig.ACCESS_TOKEN,auth_res.data.accessToken)

                    localStorage.setItem(LocalStorageConfig.AutoLoginInfo,JSON.stringify({type:payload.snsChannel,snsId:payload.snsId,autoLogin:true}));


                    let loginInfoString = localStorage.getItem(LocalStorageConfig.AutoLoginInfo);
                    console.log(`LoginStore.actions.LOGIN_WITH_SNS_EVENT -> loginInfoString : ${JSON.stringify(loginInfoString)}`);

                    //get MemberInfo
                    Axios.get(MemberApi.GET_MEMBER_INFO)
                    .then(member_res =>{   
                      
                      if(member_res.code == '0000'){
                        store.commit(LoginConfig.MEMBER_DATA,member_res.data)
                        store.commit(LoginConfig.LOGIN_STATE,true)
                        resolve()
                      }else{
                        reject(member_res)
                      }
                    })
                    .catch(err => {
                      reject(err)
                  })
                }
              })
              .catch(err => {
                reject(err)
              })
            }else{
              resolve();
            }         
          }else{            
            reject(login_res)            
          }
        })
        .catch(err => {
          // console.log(`LoginStore.actions.LOGIN_WITH_SNS_EVENT -> err : ${JSON.stringify(err)}`);
          reject(err)
        })
      })
    },

    [LoginConfig.KAKAO_LOGIN]: (store, payload) => {

      return new Promise(async(resolve,reject) => {
        // Kakao initialized check  구문 필요
        if(!store.getters[LoginConfig.KAKAO_INIT]){
          console.log(`LoginStore.actions.KAKAO_LOGIN -> init_kakao : ${store.getters[LoginConfig.KAKAO_INIT]}`);
          window.Kakao.init(AppConfig.VUE_APP_KAKAO.KEY)      
          store.commit(LoginConfig.KAKAO_INIT, true)
        }      
          

        window.Kakao.Auth.login({
          scope: 'account_email',
          success: (authObj) => {
            
            console.log(`LoginStore.actions.KAKAO_LOGIN -> login -> authObj : ${JSON.stringify(authObj)}`);

            // window.Kakao.API.request({url: '/v2/user/me'})
            window.Kakao.API.request({url: AppConfig.VUE_APP_KAKAO.URL,data:{property_keys:['kakao_account.profile','kakao_account.birthday','kakao_account.birthyear']}})
            // window.Kakao.API.request({url: AppConfig.VUE_APP_KAKAO.URL})
            .then((data) => {
              console.log(`LoginStore.actions.KAKAO_LOGIN -> login.request(/v2/user/me)1 -> data : ${JSON.stringify(data)}`);
              let kakao_account = data.kakao_account
              console.log(`LoginStore.actions.KAKAO_LOGIN -> login.request(/v2/user/me)1 -> kakao_account : ${JSON.stringify(kakao_account)}`);
              //회원가입 여부 확인
              store.dispatch(LoginConfig.LOGIN_WITH_SNS_EVENT,{
                snsChannel:'KAKAO',
                snsId:data.id,
                email:data.kakao_account.email
              })
              .then(res =>{                
                resolve(res)
              })
              .catch(err =>{
                // {\"id\":1577608654,\"connected_at\":\"2020-12-29T05:01:42Z\",\"kakao_account\":{\"profile_needs_agreement\":true,\"has_email\":true,\"email_needs_agreement\":false,\"is_email_valid\":true,\"is_email_verified\":true,\"email\":\"kids016@naver.com\",\"has_birthday\":false,\"birthday_needs_agreement\":true,\"has_gender\":false,\"gender_needs_agreement\":true}}"                
                // 회원이 아닌경우 회원가입 처리
                
                console.log(`LoginStore.actions.KAKAO_LOGIN ->  dispatch.catch -> LOGIN_WITH_SNS_EVENT -> err: ${JSON.stringify(err)}`);

                console.log(`LoginStore.actions.KAKAO_LOGIN -> login.request(/v2/user/me)1 -> kakao_account : ${JSON.stringify(kakao_account)}`);

                

                // let birthday = kakao_account.birthyear || '' + kakao_account.birthday || ''
                var birthday=''
                if(kakao_account.birthyear)
                  birthday +=kakao_account.birthyear
                  if(kakao_account.birthyear)
                  birthday +=kakao_account.birthday

                let gender='F'
                if(kakao_account.has_gender){
                  if(kakao_account.gender == 'male')
                    gender = 'M'
                  else
                    gender = 'F'
                }
                var nickname
                // if(kakao_account.profile){
                //   nickname = kakao
                // }
                  
                if(kakao_account.has_email){
                  let join_data = {
                    appId:kakao_account.email,
                    password:'',
                    snsChannel:'KAKAO',
                    snsId:data.id,
                    name:'',
                    gender:gender||'',
                    mobile:kakao_account.phone_number || '',
                    birth:birthday||'',
                    ci:kakao_account.ci,		
                    di:'',		
                    termsAgree:'N',		
                    privateAgree:'N',		
                    positionAgree:'N',		
                    marketingSMSAgree:'N',		
                    marketingPushAgree:'N',		
                    marketingEmailAgree	:'N'
                  }
                  
                  //회원 가입
                  store.dispatch(LoginConfig.JOIN_EVENT,join_data)
                  .then(res =>{
                    //JOIN_EVENT
                    console.log(`LoginStore.actions.KAKAO_LOGIN ->  JOIN_EVENT -> res: ${JSON.stringify(res)}`);
                    // resolve({})
                    store.dispatch(LoginConfig.LOGIN_WITH_SNS_EVENT,{"snsChannel":"KAKAO","snsId":data.id,"email":kakao_account.email})
                  })
                  .catch(err =>{
                    console.log(`LoginStore.actions.KAKAO_LOGIN ->  dispatch.catch -> JOIN_EVENT -> err: ${JSON.stringify(err)}`);
                  })                  
                }                
              })
            })
          },
          fail: (err) => {
            console.log(`LoginStore.actions.KAKAO_LOGIN fail -> err : ${JSON.stringify(err)}`);            
          }
        })
      })
    },
    [LoginConfig.KAKAO_LOGOUT]: (store, payload) => {
      
      console.log(`LoginStore.actions.KAKAO_LOGOUT`); 

      window.Kakao.API.request({url: '/v1/user/unlink'})
      .then(res =>{                
        console.log(`LoginStore.actions.KAKAO_LOGOUT -> res : ${JSON.stringify(res)}`); 
        resolve(res)
      })
      .catch(err =>{
        console.log(`LoginStore.actions.KAKAO_LOGOUT err -> err : ${JSON.stringify(err)}`);    
        reject()
      })

    },

    // Naver
    [LoginConfig.NAVER_LOGIN]: (store, payload) => {
      //   --open --hot --host 0.0.0.0 --port 1002 --disable-host-check
      const naverLogin = new naver.LoginWithNaverId({
        clientId: AppConfig.VUE_APP_NAVER.ID,
        callbackUrl: 'http://localhost:1002/login',
        isPopup: true,
        callbackHandler: true,
        // loginButton: {color: 'green', type: 3, height: 60}
      });
      naverLogin.init();

      naverLogin.getLoginStatus(function(status) {
        console.log(status)
        if(status) {
          let email = naverLogin.user.getEmail();
        }
      })

    },
    [LoginConfig.NAVER_LOGOUT]: (store, payload) => {

    },

    // Google
    [LoginConfig.GOOGLE_LOGIN]: (store, payload) => {

      let auth2 = gapi.auth2.init({
        client_id: '887115164241-u554qm6ngq0h8739jj5n3kjsfe9ecpo3.apps.googleusercontent.com',
        cookiepolicy: 'single_host_origin',
        scope: 'profile'
      });

      const option = new gapi.auth2.SigninOptionsBuilder();
      let googleUser = auth2.currentUser.get();
      googleUser.grant(option)
      .then((data) => {
        // console.log(data);
        console.log(data.xt.du, data.xt.Ad)

        // return GongCha API Call
      })
      .then((data) => {
          store.commit(LoginConfig.LOGIN_EVENT, {code: '1000', message: '', needDi: 'N', dormanYn: 'N'})
      })
      .catch((error) => {
        console.log(JSON.stringify({message: "error", value: error}));
      })
    },
    [LoginConfig.GOOGLE_LOGOUT]: (store, payload) => {

    },


  },
  
}
export default LoginStore;


// WEBPACK FOOTER //
// ./src/store/member/LoginStore.js